import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CDN_TYPE_CMS, imageUrlCDN } from 'utils';

import { PromotionCard } from '@atlas/components';
import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button, Icon } from '@atlas/ui';

const Card = ({ buttonSize = 'big', buttonText, description, id, imageUrl, layout, link }) => {
  const promotions = SiteConfigManager.getComponentPath(COMPONENT_TYPES.PROMOTIONS);
  const imgURL = imageUrlCDN(imageUrl, CDN_TYPE_CMS);
  const promoDetailsPage = `${promotions}/${id}`;
  return (
    <PromotionCard
      ButtonComponent={() => (
        <Link to={link || promoDetailsPage}>
          <Button label={buttonText || 'promo_button_empty'} size={buttonSize} type="primary" />
        </Link>
      )}
      description={description}
      imageUrl={imgURL}
      key={id}
      layoutType={layout}
      {...(link && {
        renderInfoButton: ({ className }) => (
          <Link className={className} to={promoDetailsPage}>
            <Icon height={18} name="info" width={18} />
          </Link>
        ),
      })}
      isMobile
      showPromoButtons
    />
  );
};

Card.propTypes = {
  buttonSize: PropTypes.string,
  buttonText: PropTypes.string,
  description: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageUrl: PropTypes.string,
  layout: PropTypes.oneOf(['labeled', 'default']),
  link: PropTypes.string,
};

export default Card;
